<div *ngIf="result !== undefined && result !== null && result.Items.length > 0">
    <div><p class="searchResultCategoryHeader">{{result.CategoriesTitle}}</p></div>
    <div *ngFor="let category of result.Categories" class="searchResultCategory">
        <a href="javascript:void(0);" (click)="filterResults(category)" [ngClass]="{'selected': filterBy===category.Category}">{{category.Category}} ({{category.Count}})</a>
    </div>
</div>
